"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7533],{

/***/ 9761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var HeartOutline = function HeartOutline(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 81 76",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_4529_10429)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("mask", {
        id: "prefix__a",
        fill: "#fff",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C33.153.883 29.941.25 25.374.25 13.14.25 4.25 10.638 4.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C70.707 44.16 76.25 34.319 76.25 24.13 76.25 10.781 67.276.302 55.151.25z"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        clipRule: "evenodd",
        d: "M55.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C33.153.883 29.941.25 25.374.25 13.14.25 4.25 10.638 4.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C70.707 44.16 76.25 34.319 76.25 24.13 76.25 10.781 67.276.302 55.151.25z",
        stroke: "#fff",
        strokeWidth: 14,
        strokeLinecap: "round",
        shapeRendering: "geometricPrecision",
        mask: "url(#prefix__a)"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_4529_10429",
        x: 0.25,
        y: 0.25,
        width: 80,
        height: 75.5,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4529_10429"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4529_10429",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoHeartOutline = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(HeartOutline);
/* harmony default export */ __webpack_exports__["Z"] = (MemoHeartOutline);

/***/ }),

/***/ 42924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Info = function Info(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 73 74",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_6065_9895)",
      fill: "#fff",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M33.125 23.998a3 3 0 116 0 3 3 0 01-6 0zM33.125 35.998a3 3 0 016 0v12a3 3 0 01-6 0v-12z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.125 35.998c0-16.56 13.44-30 30-30 16.56 0 30 13.44 30 30 0 16.56-13.44 30-30 30-16.56 0-30-13.44-30-30zm6 0c0 13.23 10.77 24 24 24s24-10.77 24-24-10.77-24-24-24-24 10.77-24 24z"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_6065_9895",
        x: 2.125,
        y: 5.998,
        width: 68,
        height: 68,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6065_9895"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6065_9895",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoInfo = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Info);
/* harmony default export */ __webpack_exports__["Z"] = (MemoInfo);

/***/ }),

/***/ 41127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Playlist = function Playlist(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 93 92",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#prefix__filter0_d_6060_10885)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M74.68 60.607c0 3.19-5.26 3.19-5.26 0v-5.153h-4.824c-3.461 0-3.461-4.807 0-4.807l4.825-.04v-5.214c0-3.19 5.258-3.19 5.258 0v5.214l4.775.04c3.395 0 3.395 4.807 0 4.807H74.68v5.153z",
        fill: "#fff"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#prefix__filter1_d_6060_10885)",
      fill: "#fff",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M14.138 24.47h63.73c5.678 0 5.678 8.62 0 8.62h-63.73c-5.68 0-5.68-8.62 0-8.62zM14.138 58.913H53.06c5.678 0 5.678 8.618 0 8.618H14.138c-5.68 0-5.68-8.619 0-8.619zM14.138 41.69H53.06c5.678 0 5.678 8.62 0 8.62H14.138c-5.68 0-5.68-8.62 0-8.62z"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_6060_10885",
        x: 58,
        y: 43,
        width: 28,
        height: 28,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6060_10885"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6060_10885",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter1_d_6060_10885",
        x: 5.879,
        y: 24.471,
        width: 80.248,
        height: 51.06,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6060_10885"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6060_10885",
          result: "shape"
        })]
      })]
    })]
  }));
};

var MemoPlaylist = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Playlist);
/* harmony default export */ __webpack_exports__["Z"] = (MemoPlaylist);

/***/ }),

/***/ 54008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAppAudio; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hls.js/dist/hls.js
var dist_hls = __webpack_require__(67631);
var hls_default = /*#__PURE__*/__webpack_require__.n(dist_hls);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useSetState.js
var useSetState = __webpack_require__(93002);
// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./app/utils/errorTracker.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ClientJS = __webpack_require__(7875);

var sendStreamError = function sendStreamError(error) {
  var _JSON$parse;

  var clientJs = new ClientJS.ClientJS();
  var country = window.localStorage.getItem(country_context/* LOCAL_STORAGE_COUNTRY_KEY */.VL);
  var ip = country ? (_JSON$parse = JSON.parse(country)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.ip : '';

  if (error.stream && error.stream.indexOf('http://') === 0) {
    error.error = 'HTTP';
  }

  try {
    axios_default()({
      method: 'get',
      url: '/api/google-api/playback-error',
      params: {
        data: _objectSpread(_objectSpread({}, error), {}, {
          ip: ip,
          date: new Date(),
          userAgent: clientJs.getUserAgent(),
          fingerprint: clientJs.getFingerprint()
        })
      }
    });
  } catch (e) {}
};
/* harmony default export */ var errorTracker = (sendStreamError);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
;// CONCATENATED MODULE: ./app/hooks/audio.hook.ts




function audio_hook_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function audio_hook_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? audio_hook_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : audio_hook_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function parseTimeRanges(ranges) {
  var result = [];

  for (var i = 0; i < ranges.length; i++) {
    result.push({
      start: ranges.start(i),
      end: ranges.end(i)
    });
  }

  return result;
}

var initialAudioState = {
  buffered: [],
  loading: true,
  time: 0,
  duration: 0,
  paused: true,
  hasError: false,
  muted: false,
  volume: 1,
  playbackRate: 1,
  playing: false,
  streams: [],
  adStreams: [],
  activeAdStream: null,
  activeStream: null,
  activeAdStreamIndex: 0,
  activeStreamIndex: 0
};
function useAppAudio(_ref, dependencies) {
  var artwork = _ref.artwork,
      artist = _ref.artist,
      title = _ref.title,
      isFavorite = _ref.isFavorite,
      streamType = _ref.streamType,
      onFavoriteToggle = _ref.onFavoriteToggle,
      onShuffleToggle = _ref.onShuffleToggle,
      onLoopAllToggle = _ref.onLoopAllToggle,
      onLoopOneToggle = _ref.onLoopOneToggle,
      onStreamEnd = _ref.onStreamEnd,
      onNextTrack = _ref.onNextTrack,
      onStop = _ref.onStop,
      onPreviousTrack = _ref.onPreviousTrack,
      onSeekForward = _ref.onSeekForward,
      onSeekBackward = _ref.onSeekBackward,
      onAdStreamEnd = _ref.onAdStreamEnd,
      audioProps = _ref.audioProps,
      streams = _ref.streams,
      adStreams = _ref.adStreams,
      _ref$autoplay = _ref.autoplay,
      autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
      onPlaybackError = _ref.onPlaybackError,
      favoritesEnabled = _ref.favoritesEnabled,
      streamsLoading = _ref.streamsLoading,
      initialProgress = _ref.initialProgress,
      _ref$liveStream = _ref.liveStream,
      liveStream = _ref$liveStream === void 0 ? false : _ref$liveStream,
      permalink = _ref.permalink;

  var _useSetState = (0,useSetState/* default */.Z)(initialAudioState),
      _useSetState2 = (0,slicedToArray/* default */.Z)(_useSetState, 2),
      state = _useSetState2[0],
      setState = _useSetState2[1];

  var ref = (0,react.useRef)(null);
  var backgroundRef = (0,react.useRef)(null);
  var hls = (0,react.useRef)(null);

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      forceMediaSession = _useFeaturesContext.forceMediaSession;

  var wrapEvent = function wrapEvent(userEvent, proxyEvent) {
    return function (event) {
      try {
        proxyEvent && proxyEvent(event);
      } finally {
        userEvent && userEvent(event);
      }
    };
  };

  var playBackgroundStream = function playBackgroundStream() {
    if (forceMediaSession && backgroundRef.current) {
      backgroundRef.current.play().catch(console.log);
    }
  };

  var pauseBackgroundStream = function pauseBackgroundStream() {
    if (forceMediaSession && backgroundRef.current) {
      backgroundRef.current.pause();
    }
  };

  var onPlay = function onPlay() {
    setState({
      paused: false
    });
  };

  var onPlaying = function onPlaying() {
    pauseBackgroundStream();
    setState({
      paused: false,
      playing: true,
      loading: false
    });
  };

  var onWaiting = function onWaiting() {
    // console.log("ON WAITING");
    playBackgroundStream();
    setState({
      playing: false,
      loading: true
    });
  };

  var onPause = function onPause() {
    setState({
      paused: true,
      playing: false,
      loading: false
    });
  };

  var onStalled = function onStalled() {// if (!state.paused) {
    //   setState({ loading: true });
    // }
  };

  var onCanPlay = function onCanPlay(e) {// console.log("onCanPlay", e);
    // if (!state.paused) {
    //   setState({ loading: true });
    // }
  };

  var onLoadedMetadata = function onLoadedMetadata() {
    if (ref.current && initialProgress !== undefined) {
      ref.current.currentTime = initialProgress;
    }
  };

  var onLoadedData = function onLoadedData() {
    setState({
      loading: false
    });
  };

  var onVolumeChange = function onVolumeChange() {
    var el = ref.current;

    if (!el) {
      return;
    }

    setState({
      muted: el.muted,
      volume: el.volume
    });
  };

  var onDurationChange = function onDurationChange() {
    var el = ref.current;

    if (!el) {
      return;
    }

    var duration = el.duration,
        buffered = el.buffered,
        currentTime = el.currentTime,
        playbackRate = el.playbackRate;
    setState({
      duration: duration
    });
  };

  var onRateChange = function onRateChange() {
    var el = ref.current;

    if (!el) {
      return;
    }

    var playbackRate = el.playbackRate;
    setState({
      playbackRate: playbackRate
    });
  };

  var onTimeUpdate = function onTimeUpdate() {
    var el = ref.current;

    if (!el) {
      return;
    }

    setState({
      time: el.currentTime
    });
  };

  var onProgress = function onProgress() {
    var el = ref.current;

    if (!el) {
      return;
    }

    setState({
      buffered: parseTimeRanges(el.buffered)
    });
  };

  var onError = (0,react.useCallback)(function (e) {
    console.log("onError", e);

    if (state.activeAdStream) {
      setState(function (prevState) {
        return {
          activeAdStreamIndex: prevState.activeAdStreamIndex + 1
        };
      });
    } else if (state.activeStream) {
      if (state.streams.length > 0 && state.activeStreamIndex >= state.streams.length - 1 && window.navigator.onLine) {
        var _state$activeStream, _state$activeStream$u;

        setState({
          paused: true,
          playing: false,
          loading: false,
          hasError: true
        });
        playBackgroundStream();
        onPlaybackError && onPlaybackError((_state$activeStream = state.activeStream) === null || _state$activeStream === void 0 ? void 0 : (_state$activeStream$u = _state$activeStream.url) === null || _state$activeStream$u === void 0 ? void 0 : _state$activeStream$u.startsWith("https"));
      }

      if (permalink) {
        var _state$activeStream2;

        errorTracker({
          permalink: permalink,
          stream: (_state$activeStream2 = state.activeStream) === null || _state$activeStream2 === void 0 ? void 0 : _state$activeStream2.url,
          error: e.type
        });
      }

      setState(function (prevState) {
        return {
          activeStreamIndex: prevState.activeStreamIndex + 1
        };
      });
    }
  }, [state]);

  var playStream = function playStream(stream) {
    if (ref.current) {
      var _stream$format, _stream$protocol;

      var retryCount = 0;
      ref.current.volume = 0.7;
      setState({
        loading: true
      });
      ref.current.pause();

      if (hls.current != null) {
        // console.log("REGULAR STREAM");
        hls.current.destroy();
      }

      if (hls_default().isSupported() && ((_stream$format = stream.format) !== null && _stream$format !== void 0 && _stream$format.includes("hls") || (_stream$protocol = stream.protocol) !== null && _stream$protocol !== void 0 && _stream$protocol.includes("hls"))) {
        // console.log("HLS STREAM");
        var config = {
          debug: false
        };
        hls.current = new (hls_default())(config);
        hls.current.loadSource(stream.url);
        hls.current.attachMedia(ref.current);
        hls.current.on((hls_default()).Events.MANIFEST_PARSED, function () {
          if (autoplay) {
            var _ref$current;

            (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.play().catch(function (e) {
              console.log("HLS could not play audio", e);
            });
          }
        });
        hls.current.on((hls_default()).Events.ERROR, function (event, data) {
          var _hls$current2, _hls$current3;

          console.log("HLS ERROR");
          console.error(event, data);

          switch (data.type) {
            case (hls_default()).ErrorTypes.NETWORK_ERROR:
              if (data.details === (hls_default()).ErrorDetails.MANIFEST_LOAD_ERROR) {
                onError(data);
              } else {
                if (retryCount < 3) {
                  var _hls$current;

                  retryCount++;
                  (_hls$current = hls.current) === null || _hls$current === void 0 ? void 0 : _hls$current.startLoad();
                } else {
                  console.log("[AUDIO] HLS retry limit reached");
                  onError(data);
                }
              }

              break;

            case (hls_default()).ErrorTypes.MEDIA_ERROR:
              (_hls$current2 = hls.current) === null || _hls$current2 === void 0 ? void 0 : _hls$current2.recoverMediaError();
              break;

            default:
              (_hls$current3 = hls.current) === null || _hls$current3 === void 0 ? void 0 : _hls$current3.destroy();
              break;
          }
        });
      } else {
        // console.log("REGULAR, autoplay:", autoplay);
        ref.current.src = stream.url; // ref.current.load();

        if (autoplay) {
          controls.play();
        }
      }
    }
  };

  var onEnded = function onEnded() {
    if (state.activeAdStream) {
      setState({
        activeAdStreamIndex: 0,
        adStreams: []
      });

      if (onAdStreamEnd) {
        onAdStreamEnd();
      }
    } else {
      setState({
        paused: true,
        playing: false,
        loading: false
      });

      if (onStreamEnd) {
        onStreamEnd();
      }
    }
  };

  var controls = {
    toggle: function toggle() {
      if (state.paused) {
        controls.play();
      } else {
        controls.pause();
      }
    },
    play: function play() {
      var _state$activeStream3, _state$activeStream3$, _el$play;

      if (state.streams && state.activeStreamIndex > state.streams.length - 1) {
        setState({
          activeStreamIndex: 0,
          hasError: false
        });
      }

      if (!state.activeStream && state.activeStreamIndex < state.streams.length) {
        setState(function (prevState) {
          return {
            activeStream: prevState.streams[prevState.activeStreamIndex]
          };
        });
      }

      if (liveStream && ref.current && !state.activeAdStream && !((_state$activeStream3 = state.activeStream) !== null && _state$activeStream3 !== void 0 && (_state$activeStream3$ = _state$activeStream3.format) !== null && _state$activeStream3$ !== void 0 && _state$activeStream3$.includes("hls"))) {// ref.current.load();
      }

      var el = ref.current; // console.log("ABOUT TO PLAY", el);

      if (!el) {
        return undefined;
      }

      (_el$play = el.play()) === null || _el$play === void 0 ? void 0 : _el$play.catch(function (e) {
        return console.log("PLAYBACKERROR", e);
      }).then(function (e) {
        console.log("PLAYING!");
      });
    },
    pause: function pause() {
      var el = ref.current;

      if (!el || state.duration === undefined) {
        return;
      }

      if (el) {
        return el.pause();
      }
    },
    seek: function seek(time) {
      var el = ref.current;

      if (!el || state.duration === undefined) {
        return;
      }

      time = Math.min(state.duration, Math.max(0, time));
      el.currentTime = time;
    },
    volume: function (_volume) {
      function volume(_x) {
        return _volume.apply(this, arguments);
      }

      volume.toString = function () {
        return _volume.toString();
      };

      return volume;
    }(function (volume) {
      var el = ref.current;

      if (!el) {
        return;
      }

      volume = Math.min(1, Math.max(0, volume));
      el.volume = volume;
      setState({
        volume: volume
      });
    }),
    setPlaybackRate: function setPlaybackRate(newPlaybackRate) {
      var el = ref.current;

      if (!el) {
        return;
      }

      if (newPlaybackRate < 2 && newPlaybackRate > 0) {
        el.playbackRate = newPlaybackRate;
      }

      setState({
        playbackRate: newPlaybackRate
      });
    },
    mute: function mute() {
      var el = ref.current;

      if (!el) {
        return;
      }

      el.muted = true;
    },
    unmute: function unmute() {
      var el = ref.current;

      if (!el) {
        return;
      }

      el.muted = false;
    }
  };
  (0,react.useEffect)(function () {
    if ("mediaSession" in navigator) {
      if (streamType === "radio") {
        try {
          navigator.mediaSession.setPositionState({
            duration: Infinity,
            playbackRate: 1,
            position: 0
          });
        } catch (error) {
          console.log("setPositionState error");
        }
      }

      try {
        navigator.mediaSession.metadata = new MediaMetadata({
          title: title,
          artist: artist,
          artwork: artwork,
          type: streamType,
          favorite: isFavorite,
          favoriteEnabled: favoritesEnabled
        });
      } catch (e) {
        console.error(e);

        try {
          navigator.mediaSession.metadata = new MediaMetadata({
            title: title,
            artist: artist,
            artwork: artwork
          });
        } catch (e) {
          console.error(e);
        }

        try {
          navigator.mediaSession.metadata.type = streamType;
        } catch (e) {
          console.error(e);
        }

        try {
          navigator.mediaSession.metadata.favorite = isFavorite;
        } catch (e) {
          console.error(e);
        }

        try {
          navigator.mediaSession.metadata.favoriteEnabled = favoritesEnabled;
        } catch (e) {
          console.error(e);
        }
      }

      try {
        if (!state.loading) {
          navigator.mediaSession.playbackState = state.playing ? "playing" : "paused";
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, [title, artist, artwork, streamType, favoritesEnabled, isFavorite, state.playing, state.loading]);
  (0,react.useEffect)(function () {
    if ("mediaSession" in navigator) {
      try {
        navigator.mediaSession.metadata.playbackError = state.hasError;
      } catch (e) {
        console.error(e);
      }
    }
  }, [state.hasError]);
  (0,react.useEffect)(function () {
    if ("mediaSession" in navigator) {
      try {
        navigator.mediaSession.metadata.loading = state.loading || streamsLoading;
      } catch (e) {
        console.error(e);
      }
    }
  }, [state.loading]);
  var onMediaSessionPause = (0,react.useCallback)(function () {
    if (!state.loading) {
      controls.pause();
    }
  }, [state.loading]);
  var onMediaSessionPlay = (0,react.useCallback)(function () {
    if (!state.loading) {
      controls.play();
    }
  }, [state.loading]);
  var mediaSessionDependencies = (0,react.useMemo)(function () {
    return [].concat((0,toConsumableArray/* default */.Z)(dependencies), [onMediaSessionPause, onMediaSessionPlay, onPreviousTrack, onFavoriteToggle, onLoopOneToggle, onLoopAllToggle, onShuffleToggle]);
  }, [dependencies, onMediaSessionPause, onMediaSessionPlay, onPreviousTrack, onNextTrack, onFavoriteToggle, onLoopOneToggle, onLoopAllToggle, onShuffleToggle]);
  (0,react.useEffect)(function () {
    if ("mediaSession" in navigator) {
      try {
        navigator.mediaSession.setActionHandler("play", onMediaSessionPlay);
      } catch (e) {
        console.error(e);
      }

      try {
        navigator.mediaSession.setActionHandler("pause", onMediaSessionPause);
      } catch (e) {
        console.error(e);
      }

      if (streamType === "podcast") {
        try {
          navigator.mediaSession.setActionHandler("seekbackward", function () {
            onSeekBackward && onSeekBackward();
          });
        } catch (e) {
          console.error(e);
        }

        try {
          navigator.mediaSession.setActionHandler("seekforward", function () {
            onSeekForward && onSeekForward();
          });
        } catch (e) {
          console.error(e);
        }
      } else {
        try {
          navigator.mediaSession.setActionHandler("seekbackward", null);
        } catch (e) {
          console.error(e);
        }

        try {
          navigator.mediaSession.setActionHandler("seekforward", null);
        } catch (e) {
          console.error(e);
        }
      }

      try {
        navigator.mediaSession.setActionHandler("stop", function () {
          controls.pause();
          onStop && onStop();
        });
      } catch (e) {
        console.error(e);
      }

      try {
        navigator.mediaSession.setActionHandler("previoustrack", onPreviousTrack || null);
      } catch (e) {
        console.error(e);
      }

      try {
        navigator.mediaSession.setActionHandler("nexttrack", onNextTrack || null);
      } catch (e) {
        console.error(e);
      }

      try {
        navigator.mediaSession.setActionHandler("favorite", function (event) {
          onFavoriteToggle && onFavoriteToggle(event.enable);
        });
        navigator.mediaSession.setActionHandler("shuffle", function (event) {
          onShuffleToggle && onShuffleToggle(event.enable);
        });
        navigator.mediaSession.setActionHandler("loopone", function (event) {
          try {
            onLoopOneToggle && onLoopOneToggle(event.enabled);
          } catch (e) {}
        });
        navigator.mediaSession.setActionHandler("loopall", function (event) {
          try {
            onLoopAllToggle && onLoopAllToggle(event.enable);
          } catch (e) {}
        });
      } catch (e) {}
    }
  }, mediaSessionDependencies);
  (0,react.useEffect)(function () {
    controls.pause();
    setState(initialAudioState);
  }, dependencies);
  (0,react.useEffect)(function () {
    if (!streamsLoading) {
      setState({
        streams: streams,
        adStreams: adStreams
      });
    }
  }, [streams, adStreams, streamsLoading]);
  (0,react.useEffect)(function () {
    setState(function (prevState) {
      return {
        activeStream: prevState.streams[prevState.activeStreamIndex],
        activeAdStream: prevState.adStreams[prevState.activeAdStreamIndex]
      };
    });
  }, [state.streams, state.adStreams, state.activeAdStreamIndex, state.activeStreamIndex]);
  (0,react.useEffect)(function () {
    if (state.activeAdStream) {
      playStream(state.activeAdStream.stream);
    } else if (state.activeStream) {
      playStream(state.activeStream);
    }
  }, [state.activeStream, state.activeAdStream]);
  var audioElement = /*#__PURE__*/(0,react.createElement)("audio", audio_hook_objectSpread(audio_hook_objectSpread({
    controls: false
  }, audioProps), {}, {
    ref: ref,
    onEnded: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onEnded, onEnded),
    onPlay: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onPlay, onPlay),
    onPlaying: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onPlaying, onPlaying),
    onWaiting: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onWaiting, onWaiting),
    onPause: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onPause, onPause),
    onError: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onError, onError),
    onStalled: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onStalled, onStalled),
    onLoadedMetadata: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onLoadedMetadata, onLoadedMetadata),
    onCanPlay: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onCanPlay, onCanPlay),
    onLoadedData: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onLoadedData, onLoadedData),
    onVolumeChange: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onVolumeChange, onVolumeChange),
    onDurationChange: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onDurationChange, onDurationChange),
    onRateChange: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onRateChange, onRateChange),
    onTimeUpdate: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onTimeUpdate, onTimeUpdate),
    onProgress: wrapEvent(audioProps === null || audioProps === void 0 ? void 0 : audioProps.onProgress, onProgress)
  }));
  var fallbackAudioElement = forceMediaSession ? /*#__PURE__*/(0,react.createElement)("audio", {
    controls: false,
    loop: true,
    ref: backgroundRef,
    src: "/10-seconds-of-silence.mp3"
  }) : null;
  return {
    audioElement: audioElement,
    fallbackAudioElement: fallbackAudioElement,
    state: state,
    controls: controls,
    audioRef: ref
  };
}

/***/ }),

/***/ 28395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useSpacebarEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useSpacebarEvent = function useSpacebarEvent(onSpace) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var eventHandler = function eventHandler(event) {
      var path = event === null || event === void 0 ? void 0 : event.composedPath();

      if (event.key === " " && path[0].nodeName !== "INPUT" && path[0].nodeName !== "TEXTAREA") {
        onSpace();
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", eventHandler);
    return function () {
      return document.removeEventListener("keydown", eventHandler);
    };
  }, [onSpace]);
};

/***/ }),

/***/ 21075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ useAudioAds; },
/* harmony export */   "q3": function() { return /* binding */ TargetspotEventType; }
/* harmony export */ });
/* unused harmony exports sendTargetspotTrackingEvent, sendImpressions */
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var app_store_slices_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22564);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38886);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4062);
/* harmony import */ var app_utils_language__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79490);
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10833);
/* harmony import */ var date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43012);
/* harmony import */ var _dailymotion_vast_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30248);
/* harmony import */ var _dailymotion_vast_client__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dailymotion_vast_client__WEBPACK_IMPORTED_MODULE_7__);










var TargetspotEventType;

(function (TargetspotEventType) {
  TargetspotEventType["Start"] = "start";
  TargetspotEventType["FirstQuartile"] = "firstQuartile";
  TargetspotEventType["Midpoint"] = "midpoint";
  TargetspotEventType["ThirdQuartile"] = "thirdQuartile";
  TargetspotEventType["Complete"] = "complete";
  TargetspotEventType["Pause"] = "pause";
  TargetspotEventType["Rewind"] = "rewind";
  TargetspotEventType["Resume"] = "resume";
})(TargetspotEventType || (TargetspotEventType = {}));

var getEvents = function getEvents(events, type) {
  return events.filter(function (item) {
    return item.EventStr === type;
  });
};

var sendTargetspotTrackingEvent = function sendTargetspotTrackingEvent(events, type) {
  var sameTypeEvents = getEvents(events, type);

  if (sameTypeEvents && sameTypeEvents.length) {
    sameTypeEvents.forEach(function (event) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", event.Value, true);
      xhr.send();
    });
  }
};
var sendImpressions = function sendImpressions(events) {
  events.forEach(function (eventUrl) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", eventUrl, true);
    xhr.send();
  });
};

var getStationId = function getStationId(config, category) {
  var stationid = "";

  if (category.type === "radio") {
    var _config$stationID, _config$stationID$rad, _category$tags;

    stationid = config === null || config === void 0 ? void 0 : (_config$stationID = config.stationID) === null || _config$stationID === void 0 ? void 0 : (_config$stationID$rad = _config$stationID.radio) === null || _config$stationID$rad === void 0 ? void 0 : _config$stationID$rad.default;
    (_category$tags = category.tags) === null || _category$tags === void 0 ? void 0 : _category$tags.forEach(function (tag) {
      if (tag.permalink && config.stationID.radio[tag.permalink]) {
        stationid = config.stationID.radio[tag.permalink];
      }
    });
  } else {
    var _category$tags2;

    stationid = config.stationID.podcast.default;
    (_category$tags2 = category.tags) === null || _category$tags2 === void 0 ? void 0 : _category$tags2.forEach(function (tag) {
      if (tag.permalink && config.stationID.podcast[tag.permalink]) {
        stationid = config.stationID.podcast[tag.permalink];
      }
    });
  }

  return stationid;
};

var initialTargetspotTimeEventsStatus = {
  firstQuartile: false,
  midpoint: false,
  thirdQuartile: false
};

var parseAdTonosTrackingEvents = function parseAdTonosTrackingEvents(adTonosAdData) {
  var _adTonosAdData$adInde;

  var adIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var adTonosEvents = [];
  Object.keys((_adTonosAdData$adInde = adTonosAdData[adIndex]) === null || _adTonosAdData$adInde === void 0 ? void 0 : _adTonosAdData$adInde.creatives[0].trackingEvents).forEach(function (key) {
    var _adTonosAdData$adInde2;

    (_adTonosAdData$adInde2 = adTonosAdData[adIndex]) === null || _adTonosAdData$adInde2 === void 0 ? void 0 : _adTonosAdData$adInde2.creatives[0].trackingEvents[key].forEach(function (event) {
      adTonosEvents.push({
        EventStr: key,
        Value: event
      });
    });
  });
  return adTonosEvents;
};

var gdprConsent = "";

var updateGdprConsent = function updateGdprConsent() {
  //update gdpr consent
  if (true) {
    try {
      window.__tcfapi("getTCData", 2, function (tcData, success) {
        if (success) {
          gdprConsent = tcData === null || tcData === void 0 ? void 0 : tcData.tcString;
        } else {// do something else
        }
      });
    } catch (e) {}
  }
};

var useAudioAds = function useAudioAds(category) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      adData = _useState[0],
      setAdData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      trackingEvents = _useState2[0],
      setTrackingEvents = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      impressions = _useState3[0],
      setImpressions = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      adError = _useState4[0],
      setAdError = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialTargetspotTimeEventsStatus),
      trackingTimeEventsStatus = _useState5[0],
      setTrackingTimeEventsStatus = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      adStreamsLoading = _useState6[0],
      setAdStreamsLoading = _useState6[1];

  var _useAppSelector = (0,app_store_store__WEBPACK_IMPORTED_MODULE_4__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_3__/* .selectUserState */ .tH),
      session = _useAppSelector.session,
      deviceId = _useAppSelector.deviceId,
      ip = _useAppSelector.ip,
      lastAdCompletedDate = _useAppSelector.lastAdCompletedDate;

  var _useAppSelector2 = (0,app_store_store__WEBPACK_IMPORTED_MODULE_4__/* .useAppSelector */ .CG)(app_store_slices_player__WEBPACK_IMPORTED_MODULE_2__/* .selectPlayerState */ .tA),
      targetspotConfig = _useAppSelector2.targetspotConfig;

  var _useFeaturesContext = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_6__/* .useFeaturesContext */ .Pp)(),
      targetspotEnabled = _useFeaturesContext.targetspotEnabled,
      targetspotApikey = _useFeaturesContext.targetspotApikey,
      targetspotUrl = _useFeaturesContext.targetspotUrl,
      targetspotStaging = _useFeaturesContext.targetspotStaging;

  var sendTrackingEvent = function sendTrackingEvent(eventType) {
    sendTargetspotTrackingEvent(trackingEvents, eventType);
  }; //update gdpr consent


  updateGdprConsent();

  var shouldPlayAdBasedOnTime = function shouldPlayAdBasedOnTime() {
    return lastAdCompletedDate ? (0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Date.now(), lastAdCompletedDate) >= 60 : true;
  };

  var sendTargetspotStateUpdateEvent = function sendTargetspotStateUpdateEvent(state) {
    if (state.playing && state.time === 0) {
      sendTargetspotTrackingEvent(trackingEvents, TargetspotEventType.Start);
      sendImpressions(impressions);
    }

    if (state.playing && state.time !== 0) {
      sendTargetspotTrackingEvent(trackingEvents, TargetspotEventType.Resume);
    }

    if (state.paused && state.time !== 0 && state.time !== state.duration) {
      sendTargetspotTrackingEvent(trackingEvents, TargetspotEventType.Pause);
    }
  };

  var adTonosRequest = /*#__PURE__*/function () {
    var _ref = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var adTonosRequestUrl, vastClient, _adTonosAdData$, parsedVAST, adTonosAdData, adTonosEvents;

      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("adTonosRequest");
              setAdStreamsLoading(true);
              adTonosRequestUrl = "https://vast.adtonos.com/xml/AQpiLTK3tHkXrTuwb/vast.xml"; // "https://vast.adtonos.com/xml/sC63j5bdwaHkjGok4/vast.xml"; // test station

              vastClient = new _dailymotion_vast_client__WEBPACK_IMPORTED_MODULE_7__.VASTClient();
              _context.prev = 4;
              _context.next = 7;
              return vastClient.get(adTonosRequestUrl);

            case 7:
              parsedVAST = _context.sent;
              console.log({
                parsedVAST: parsedVAST
              });
              adTonosAdData = parsedVAST.ads;

              if (!(!adTonosAdData || !adTonosAdData.length)) {
                _context.next = 16;
                break;
              }

              // No Targetspot ads
              setAdData(null);
              setTrackingEvents([]);
              setImpressions([]);
              setAdStreamsLoading(false);
              return _context.abrupt("return");

            case 16:
              setAdData(adTonosAdData);

              if (adTonosAdData[0] && adTonosAdData[0].impressionURLTemplates[0]) {
                setImpressions(adTonosAdData[0].impressionURLTemplates.map(function (item) {
                  return item.url;
                }));
              } else {
                setImpressions([]);
              }

              if ((_adTonosAdData$ = adTonosAdData[0]) !== null && _adTonosAdData$ !== void 0 && _adTonosAdData$.creatives[0]) {
                adTonosEvents = parseAdTonosTrackingEvents(adTonosAdData);
                setTrackingEvents(adTonosEvents);
              } else {
                setTrackingEvents([]);
              }

              setAdStreamsLoading(false);
              _context.next = 29;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](4);
              console.log("error");
              setAdData(null);
              setTrackingEvents([]);
              setImpressions([]);
              setAdStreamsLoading(false);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 22]]);
    }));

    return function adTonosRequest() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _session$user;

    setTrackingTimeEventsStatus(initialTargetspotTimeEventsStatus);
    setTrackingEvents([]);
    setImpressions([]);

    if (!(session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.premium) && targetspotEnabled && !!targetspotApikey && !!targetspotUrl && shouldPlayAdBasedOnTime()) {
      try {
        var _category$tags3, _session$user2, _category$tags4;

        if ((_category$tags3 = category.tags) !== null && _category$tags3 !== void 0 && _category$tags3.length) {
          var refuseTag = category.tags.find(function (tag) {
            return tag.name === "RefuseAudioAds";
          });

          if (refuseTag) {
            throw new Error("Adstream refused by the tag");
          }
        }

        var targetspotUrlObj = new URLSearchParams({
          apikey: targetspotApikey,
          culture: (0,app_utils_language__WEBPACK_IMPORTED_MODULE_5__/* .getNavigatorLanguage */ .BE)().replaceAll("_", "-"),
          domain: "radioline.co",
          format: "json",
          gdpr: gdprConsent ? "1" : "0",
          gdpr_consent: gdprConsent || "",
          ip: ip || "",
          placement: "preroll",
          product: category.type === "radio" ? "radiostreaming" : "podcaststreaming",
          stationid: targetspotStaging ? "radioline-staging" : getStationId(targetspotConfig, category),
          useragent: navigator.userAgent,
          userid: (session === null || session === void 0 ? void 0 : (_session$user2 = session.user) === null || _session$user2 === void 0 ? void 0 : _session$user2.id) || deviceId,
          visualmode: "1"
        });

        if (category.type === "podcast" && (_category$tags4 = category.tags) !== null && _category$tags4 !== void 0 && _category$tags4.length) {
          var topicTags = category.tags.filter(function (tag) {
            return tag.tagType === "topic";
          });

          if (topicTags.length) {
            var _topicTags$0$searchNa;

            targetspotUrlObj.append("contentformat-applepodcast", ((_topicTags$0$searchNa = topicTags[0].searchName) === null || _topicTags$0$searchNa === void 0 ? void 0 : _topicTags$0$searchNa.replace("tags.topic.", "")) || "unknown");
          }
        }

        setAdStreamsLoading(true);
        var targetspotRequestUrl = targetspotUrl + "?" + targetspotUrlObj.toString();
        var xhr = new XMLHttpRequest();
        xhr.open("GET", targetspotRequestUrl, true);
        xhr.responseType = "json";
        xhr.addEventListener("load", /*#__PURE__*/(0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
          var _adData$0$InLine, _adData$0$InLine3, _adData, _adData$0$InLine2, _adData$0$InLine4, _adData$0$InLine4$Cre;

          return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(xhr.status === 200)) {
                    _context2.next = 10;
                    break;
                  }

                  _adData = xhr.response.Ads;
                  console.log({
                    adData: _adData
                  });

                  if (!(!_adData || !_adData.length)) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.next = 6;
                  return adTonosRequest();

                case 6:
                  return _context2.abrupt("return");

                case 7:
                  setAdData(_adData);

                  if (_adData && _adData[0] && (_adData$0$InLine = _adData[0].InLine) !== null && _adData$0$InLine !== void 0 && _adData$0$InLine.Impressions[0]) {
                    setImpressions((_adData$0$InLine2 = _adData[0].InLine) === null || _adData$0$InLine2 === void 0 ? void 0 : _adData$0$InLine2.Impressions.map(function (impression) {
                      return impression.Value;
                    }));
                  } else {
                    setImpressions([]);
                  }

                  if (_adData && _adData[0] && (_adData$0$InLine3 = _adData[0].InLine) !== null && _adData$0$InLine3 !== void 0 && _adData$0$InLine3.Creatives[0]) {
                    setTrackingEvents((_adData$0$InLine4 = _adData[0].InLine) === null || _adData$0$InLine4 === void 0 ? void 0 : (_adData$0$InLine4$Cre = _adData$0$InLine4.Creatives[0].Linear) === null || _adData$0$InLine4$Cre === void 0 ? void 0 : _adData$0$InLine4$Cre.TrackingEvents);
                  } else {
                    setTrackingEvents([]);
                  }

                case 10:
                  setAdStreamsLoading(false);

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
        xhr.addEventListener("error", /*#__PURE__*/(0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
          return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  setAdError(true);
                  setAdData(null);
                  setTrackingEvents([]);
                  setImpressions([]);
                  setAdStreamsLoading(false);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })));
        xhr.addEventListener("timeout", /*#__PURE__*/(0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
          return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  setAdError(true);
                  setAdData(null);
                  setTrackingEvents([]);
                  setImpressions([]);
                  setAdStreamsLoading(false);

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })));
        xhr.send();
      } catch (e) {
        setAdData(null);
        setTrackingEvents([]);
        setImpressions([]);
        setAdStreamsLoading(false);
      }
    } else {
      setAdData(null);
    }
  }, [session === null || session === void 0 ? void 0 : session.user, targetspotEnabled, targetspotApikey, targetspotUrl, category.permalink]);
  var adStreams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var ads = [];

    if (adData) {
      adData.forEach(function (ad) {
        var _ad$system;

        if (ad.InLine) {
          ad.InLine.Creatives.forEach(function (creative) {
            var adId = creative.Id;

            if (creative.Linear && creative.Linear.MediaFiles) {
              creative.Linear.MediaFiles.forEach(function (mf) {
                ads.push({
                  isAd: true,
                  adId: adId,
                  stream: {
                    url: mf.Value,
                    bitrate: mf.Bitrate
                  }
                });
              });
            }
          });
        } else if (((_ad$system = ad.system) === null || _ad$system === void 0 ? void 0 : _ad$system.value) === "AdTonos") {
          ad.creatives.forEach(function (creative) {
            var _creative$mediaFiles;

            var adId = creative.id;

            if ((_creative$mediaFiles = creative.mediaFiles) !== null && _creative$mediaFiles !== void 0 && _creative$mediaFiles.length) {
              creative.mediaFiles.forEach(function (mf) {
                ads.push({
                  isAd: true,
                  adId: adId,
                  stream: {
                    url: mf.fileURL,
                    bitrate: mf.bitrate
                  }
                });
              });
            }
          });
        }
      });
    }

    ads.sort(function (streamA, streamB) {
      return (streamB.stream.bitrate || 0) - (streamA.stream.bitrate || 0);
    });
    return ads;
  }, [adData, category.permalink]);

  var sendTargetspotTimeUpdateEvent = function sendTargetspotTimeUpdateEvent(state) {
    var progress = state.time / state.duration;

    if (progress >= 0.25 && progress < 0.5 && !trackingTimeEventsStatus.firstQuartile) {
      sendTargetspotTrackingEvent(trackingEvents, TargetspotEventType.FirstQuartile);
      setTrackingTimeEventsStatus({
        firstQuartile: true,
        midpoint: false,
        thirdQuartile: false
      });
    } else if (progress >= 0.5 && progress < 0.75 && !trackingTimeEventsStatus.midpoint) {
      sendTargetspotTrackingEvent(trackingEvents, TargetspotEventType.Midpoint);
      setTrackingTimeEventsStatus({
        firstQuartile: true,
        midpoint: true,
        thirdQuartile: false
      });
    } else if (progress >= 0.75 && progress < 1 && !trackingTimeEventsStatus.thirdQuartile) {
      sendTargetspotTrackingEvent(trackingEvents, TargetspotEventType.ThirdQuartile);
      setTrackingTimeEventsStatus({
        firstQuartile: true,
        midpoint: true,
        thirdQuartile: true
      });
    }
  };

  return {
    adStreams: adStreams,
    adStreamsLoading: adStreamsLoading,
    adError: adError,
    trackingEvents: trackingEvents,
    sendTrackingEvent: sendTrackingEvent,
    sendTargetspotTimeUpdateEvent: sendTargetspotTimeUpdateEvent,
    sendTargetspotStateUpdateEvent: sendTargetspotStateUpdateEvent
  };
};

/***/ })

}]);